import { render, staticRenderFns } from "./NewRealEstatePlusEdit.vue?vue&type=template&id=4446baca&scoped=true&"
import script from "./NewRealEstatePlusEdit.vue?vue&type=script&lang=js&"
export * from "./NewRealEstatePlusEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstatePlusEdit.vue?vue&type=style&index=0&id=4446baca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446baca",
  null
  
)

export default component.exports